import { ApolloClient } from 'apollo-boost';
import { answersQuery } from 'shared/apollo/pageHooks/useReportAnswers';
import {
  ReportStage,
  ReportStatus,
} from 'donor/portal/pages/FeedbackDashboard/api';
import { Answer } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';

export interface ReportAnswersResponse {
  stage: ReportStage;
  status: ReportStatus;
  answers: Answer[];
}

export const getReportAnswers = (
  client: ApolloClient<object>,
  reportId: number | string,
) => {
  return client.query({
    query: answersQuery,
    variables: {
      id: reportId,
    },
    fetchPolicy: 'network-only',
  });
};
